  <template>
     <!-- این کامپوننت برای ویرایش کردن اطلاعات جدول ایجاد شده است. -->
    <v-dialog
            transition="dialog-top-transition"
            max-width="300"
            v-model ='dialogsMe'
            multiple
    >
        <v-card>
            <v-toolbar
                    color="#00CE81"
                    height="45px"
                    class="toolbar"
                    elevation="0"
            >ثبت زمان
            </v-toolbar>
            <v-card-text>
                <div class="content-dialog" style="margin-top:1rem ;min-height: 300px;align-items: center;justify-content: space-around;">
                 <!-- پیاده سازی بخش های مختف برای گرفتن زمان شروع و زمان پایان -->
                  <div v-if="!autoTime" class="start-date calendar grid-help">
                     <div class="first-child">
                       <img style="width: 20px;height: 19px"
                           src="../../assets/svg/calendar.svg"
                           v-show="!dateStartDialog"
                       />
                       <img style="height: 19px;width: 20px"
                           src="../../assets/svg/calendarGreen.svg"
                           v-show="dateStartDialog"
                       />
                       <div class="titles">از تاریخ:</div>
                     </div>
                     <div class="second-child">
                       <v-chip
                           class="form-control form-control-lg time-chip"
                           :color="startBackground" :text-color="startColor" :ripple="false"
                           v-bind:class="[dateStartDialog==='' ? disActiveTarikh : activeTarikh]"
                           id="dialog-tarikh-start-mobile"
                           placeholder="تاریخ"
                           @click="showStartCalendarDialog=true"
                           v-text="datetimeStart===''?'از تاریخ':datetimeStart"
                           type="text"
                       ></v-chip>
                       <date-picker
                           convert-numbers
                           type="datetime"
                           label="از تاریخ"
                           color="#00CE81"
                           v-model="dateStartDialog"
                           element="dialog-tarikh-start-mobile"
                           clearable
                           :editable="true"
                           :max="dateEndDialog === '' ? nowTime : dateEndDialog"
                           :show="showStartCalendarDialog"
                           @close="dateStartPicker()">
                       </date-picker>
                     </div>

                  </div>
                  <div v-if="!autoTime" class="end-date calendar grid-help ">
                      <div class="first-child">
                        <img
                            style="width: 20px;height: 19px"
                            src="../../assets/svg/calendar.svg"
                            v-show="!dateEndDialog"
                        />
                        <img
                            style="width: 20px;height: 19px"
                            src="../../assets/svg/calendarGreen.svg"
                            v-show="dateEndDialog"
                        />
                        <div class="titles">تا تاریخ:</div>
                      </div>
                      <div class="second-child">
                        <v-chip
                            class="form-control form-control-lg time-chip"
                            :color="endBackground" :text-color="endColor" :ripple="false"
                            v-bind:class="[dateEndDialog==='' ? endDisActiveTarikh : endActiveTarikh]"
                            type="text"
                            id="dialog-tarikh-mobile"
                            placeholder="تا تاریخ"
                            @click="showEndCalendarDialog=true"
                            v-text="datetimeEnd===''?'تا تاریخ':datetimeEnd"
                        ></v-chip>
                        <date-picker
                            type="datetime"
                            convert-numbers
                            color="#00CE81"
                            v-model="dateEndDialog"
                            element="dialog-tarikh-mobile"
                            clearable
                            :editable="true"
                            :min="dateStartDialog==='' ? '':dateStartDialog"
                            :show="showEndCalendarDialog"
                             show-now-btn
                             @close="dateEndPicker()">
                        </date-picker>
                      </div>

                  </div>
                    <div class="project grid-help ">
                        <div class="first-child">
                          <img style="width: 20px;height: 19px"
                              src="../../assets/svg/greenProject.svg"
                              v-show="projectDialog"
                          />
                          <img style="width: 20px;height: 19px"
                              src="../../assets/svg/projectIcon.svg"
                              v-show="!projectDialog"
                          />
                          <div class="titles">انتخاب پروژه</div>
                        </div>
                        <div class="second-child">
                          <v-select
                              v-model="updateItemOfProject"
                              :items="items"
                              item-text="name"
                              v-bind:class="[projectDialog.name==='' || projectDialog.name===null ? disActiveProject : activeProject]"
                              placeholder="پروژه"
                              dense
                              rounded
                              chips
                              clearable
                              color="#00CE81"
                              item-color="green"

                          >
                            <!--item color has problem with # colors -->
                            <template #selection="{ item }">
                              <v-chip class="text-truncate" text-color="white" heaight="21px" color="#1DCCBB">{{item.name}}</v-chip>
                            </template>
                            <template v-if="projectDialog.name" v-slot:append>
                              <v-img src="../../assets/svg/menuGreen.svg"></v-img>
                            </template>
                            <template v-else v-slot:append>
                              <v-img src="../../assets/svg/menuDisable.svg"></v-img>
                            </template>
                          </v-select>
                        </div>

                    </div>
                    <div class="grid-help">
                      <select-issue :project="projectDialog" :share="myIssue" v-if="$store.state.isIntegrationSet && dataComing" :used-issue="usedIssue" :width="200" :height="35" manual-times :disable-issue="issueId===''" v-on:refreshIssue="refreshIssue" class="select-issue"></select-issue>
                    </div>
                    <div class="describes">
                        <v-textarea
                                :rows="1"
                                auto-grow
                                hide-details
                                dense
                                :row-height="12"
                                style="width: unset"
                                v-bind:class="[descriptionDialog==='' ? disActiveDescribe : activeDescribe]"
                                v-model="descriptionDialog"
                                placeholder="شرح فعالیت ..."
                                class="text--black"
                                rounded
                        ></v-textarea>
                    </div>
                    <div class="button">
                        <v-btn
                          :loading="setManualTimeLoading"
                          v-if="!autoTime"
                          v-bind:class="[dateStartDialog!==''&& dateEndDialog!==''&& descriptionDialog !=='' ? activeButton : disActiveButton]"
                          style="min-width: 0;padding: 0;border-radius: 10px"
                          width="46px"
                          height="35px"
                          :disabled="descriptionDialog ==='' || dateStartDialog===''|| dateEndDialog===''"
                          @click="setManualTime"
                      >ثبت
                      </v-btn>
                        <v-btn
                            v-else
                          :loading="updateCurrentTimeLoading"
                            v-bind:class="[ descriptionDialog !=='' ? activeButton : disActiveButton]"
                          style="min-width: 0;padding: 0;border-radius: 10px"
                          width="46px"
                          height="35px"
                          :disabled="descriptionDialog === ''"
                          @click="updateCurrentTime"
                        >ثبت
                      </v-btn>
                    </div>
                </div>
            </v-card-text>

        </v-card>
    </v-dialog>

</template>

<script>
    import { toFarsiTime, toMinutesTime} from "../../plugins/toFarsiTime";
    import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
    import {toFarsiDate} from "../../plugins/toFarsiDate";
    import {mapActions, mapGetters} from "vuex";
    import {updateTimes} from "../../api/listTime";
    import {getNowTimeWithHour} from "../../plugins/getSpecialTimes";
    import {getUtcTime} from "../../plugins/getUtcTime";
    import {postManualRecord} from "../../api/startJob"
    import { putStartJobWithId} from "@/api/startJob"
    import selectIssue from "./selectIssue";
    import integration from "../../mixin/integration";

    export default {
        //این کامپوننت فقط برای زدن دستی ایجاد شده است اما بر طبق نیاز برای حالت موبایل برای اتوماتیک هم استفاده شده است .
        name: "manualTimes",
       //کامپوننت دیت پیکر برای گرفتن زمان و تاریخ استفاده شده است به آدرس زیر است
       //https://talkhabi.github.io/vue-persian-datetime-picker/#/
        components:{
            datePicker: VuePersianDatetimePicker,
            selectIssue
        },
        //وprops برای edit در قسمت ویرایش اطلاعات و دیالوگز برای باز و بسته کردن دیالوگ که در واتچ به v-model دیالوگ وصل شده است.
        //
        props:{
            isEdit:{
              type:Boolean,
              default:false
            },
            edit: Object,
            dialogs:Boolean,
            autoTime:{
              type: Boolean,
              default: false,
            },
        },
      mixins:[integration],
      data: () => ({
        //برای پاک کردن محتویات ایشو بعد کلیک کردن
        usedIssue:false,
        issueId:'',
        myIssue:{},
        startTime:'',
        endTime:'',
        //برای استایل دهی حالت فعال و غیر فعال
        startBackground: 'inherit',
        endBackground: 'inherit',
        startColor: '#BBBBBB',
        endColor: '#BBBBBB',
        showStartCalendarDialog: false,
        showEndCalendarDialog: false,


        //زمان شروع دیت پیکر

        startDate: '',
        endDate: '',

        //برای نمایش از این قسمت استفاده می کنیم که اعداد رو بتونیم فارسی نمایش دهیم
        dateStartDialog: '',
        dateEndDialog: '',
        dateStartFarsiDialog:'',
        dateEndFarsiDialog:'',
        //زمان پیان دیت پیکر

        //برای نمایش از این قسمت استفاده می کنیم که اعداد رو بتونیم فارسی نمایش دهیم
        showCalendarDialog: false,


        //همه ی این ها برای بایند کردن کلاس css برای فعال بودن وغیر فعال بودن زده شده است
        activeTarikh: 'active-date',
        disActiveTarikh: 'dis-active-date',
        endActiveTarikh: 'end-active-date',
        endDisActiveTarikh: 'dis-end-active-date',
        activeProject: 'active-project',
        disActiveProject: 'dis-active-project',
        activeDescribe: 'active-describe',
        disActiveDescribe: 'dis-active-describe',
        activeButton: 'active-button',
        disActiveButton: 'dis-active-button',

        //گرفتن زمان الان برای اینکه در تقویم اعمال محدویدیت بکنیم که تا مثلا 30 اردیبهشت بتواند انتخاب کند زمانی که هنوز نیامده است رو انتخاب نکند
        nowTime: '',
        //دیتا های ما
        projectDialog: '',
        items: [],
        descriptionDialog: '',
        projectIdSelect: '',
        dateFarsiDialog: '',

        //بایند با v-model
        dialogsMe: true,

        // برای دکمه ها loading قرار دادم
        setManualTimeLoading: false,
        updateCurrentTimeLoading: false,

        dateStartSplit:'',
        dateEndSplit:'',
        timePersianStartSplit:'',
        timeEnglishStartSplit:'',
        timePersianEndSplit:'',
        timeEnglishEndSplit:'',
        datetimeEnd:'',
        datetimeStart:'',
        dataComing:false,
      }),
        methods:{
          refreshIssue(issue){
            this.issueId = issue
          },

          dateStartPicker() {
            this.showStartCalendarDialog = false
            this.dateStartSplit =this.dateStartDialog.split(' ')[0]
            this.timeEnglishStartSplit =this.dateStartDialog.split(' ')[1]
            if(this.dateStartDialog!=='') {
              this.dateStartFarsiDialog = toFarsiDate(this.dateStartSplit)
              this.timePersianStartSplit =toFarsiTime(toMinutesTime(this.timeEnglishStartSplit)+':00')
              this.datetimeStart =this.timePersianStartSplit+'  '+this.dateStartFarsiDialog
            }
          },
          dateEndPicker() {
            this.showEndCalendarDialog = false

            this.dateEndSplit =this.dateEndDialog.split(' ')[0]
            this.timeEnglishEndSplit =this.dateEndDialog.split(' ')[1]
            if(this.dateEndDialog!=='') {
              this.dateEndFarsiDialog = toFarsiDate(this.dateEndSplit)
              this.timePersianEndSplit =toFarsiTime( toMinutesTime(this.timeEnglishEndSplit)+':'+'00')
              this.datetimeEnd = this.timePersianEndSplit+'  '+this.dateEndFarsiDialog
            }
          },
          //این تابع برای اندازه موبایل است که بعد از اتمام کار باید این دیالوگ باز شود
          getUpdateParams(){
            if(this.projectIdSelect !== '')
            {
              if (this.issueId !== '') {
                return  {
                  project_id: this.projectIdSelect,
                  description: this.descriptionDialog,
                  time_id: this.$store.state.lastTimeId,
                  issue_id: this.issueId
                }
              }else{
                return  {
                  project_id: this.projectIdSelect,
                  description: this.descriptionDialog,
                  time_id:this.$store.state.lastTimeId,

                }
              }
            }else{
              if (this.issueId !== '') {
                return  {
                  description: this.descriptionDialog,
                  time_id: this.$store.state.lastTimeId,
                  issue_id: this.issueId
                }
              }else{
                return {
                  time_id:this.$store.state.lastTimeId,
                  description:this.descriptionDialog
                }
              }
            }
          },
          //برای وارد کردن تایم دستی
          getManualParams(){
            var moment = require('jalali-moment');
            var m = moment.from(this.dateStartDialog, 'fa', 'YYYY/MM/DD');
            let englishStartDate = m.locale('en').format('YYYY/MM/DD');
            m = moment.from(this.dateEndDialog, 'fa', 'YYYY/MM/DD');
            let englishEndDate = m.locale('en').format('YYYY/MM/DD')
            englishStartDate = englishStartDate.replace(/-|\//g, "-")
            englishEndDate = englishEndDate.replace(/-|\//g, "-")
            let startDate = getUtcTime(englishStartDate,this.startTime)
            let endDate = getUtcTime(englishEndDate,this.endTime)
            if(this.projectIdSelect !=='') {
              if (this.issueId !== '') {
                return  {
                  start_time: startDate,
                  end_time: endDate,
                  project_id: this.projectIdSelect,
                  description: this.descriptionDialog,
                  issue_id: this.issueId

                }
              }else{
                return  {
                  start_time: startDate,
                  end_time: endDate,
                  project_id: this.projectIdSelect,
                  description: this.descriptionDialog,

                }
              }
            }else{
              if (this.issueId !== '') {
                return  {
                  start_time: startDate,
                  end_time: endDate,
                  description: this.descriptionDialog,
                  issue_id: this.issueId

                }
              }else{
                return  {
                  start_time: startDate,
                  end_time: endDate,
                  description: this.descriptionDialog,

                }
              }
            }
          },
          //برای ویرایش اطلاعات
          getEditParams(){
            let params = this.getManualParams()
            params['time_id'] = this.edit.id
            return params
          },
          async setManualTime(){
                this.setManualTimeLoading = true
                if(this.projectDialog.name !== undefined && this.projectDialog.name !== null && this.projectDialog.name !== ''){
                  this.projectIdSelect = this.projectDialog.id
                }
                this.startTime = this.dateStartDialog.split(' ')[1]
                this.endTime = this.dateEndDialog.split(' ')[1]

                let params={}
                if(this.edit.id!==undefined) {
                  params = this.getEditParams()

                  if(params.time_id===this.$store.state.lastTimeId)
                  {
                    this.$store.state.lastTimeId = -1
                  }
                }else{
                     params = this.getManualParams()
                }

                try {
                    if(params.time_id!==undefined && this.isEdit)
                    {
                      try {
                        await updateTimes(params)
                        this.printAlert({type: 'success', text: 'ویرایش با موفقیت انجام شد', timeout: 5000})

                      }catch (e){
                        this.printAlert({type: 'error', text:'خطا در اعمال ویرایش', timeout:5000})
                    }
                    }
                    else{
                      await postManualRecord(params)
                      this.printAlert({type: 'success', text: 'رکورد جدید با موفقیت ثبت شد', timeout: 5000})
                    }

                  if(this.$store.state.lastTimeId === params.time_id){
                    this.$store.state.lastTimeId = -1
                  }
                    this.$emit('updateRow')
                    this.dateStartDialog = ''

                    this.dateEndDialog = ''
                    this.dateStartFarsiDialog = ""
                    this.dateEndFarsiDialog = ""
                    this.descriptionDialog = ''
                    this.projectDialog= ''
                    this.$store.state.dialogTime = false
                    this.dialogsMe = false
                    this.issueId = ''
                    this.usedIssue = !this.usedIssue
                }
                catch (e) {
                    this.dialogsMe = false
                    if (params.time_id!==undefined)
                    {
                      this.printAlert({type: 'error', text:'ویرایش با شکست مواجه شد', timeout:5000})
                    }
                    else{
                      this.printAlert({type: 'error', text:'رکورد جدید ثبت نشد', timeout:5000})
                    }
                }
                this.setManualTimeLoading=false
            },
            async updateCurrentTime(){
            this.updateCurrentTimeLoading=true
            let params = {}

            if(this.projectDialog.name !== undefined && this.projectDialog.name !== null && this.projectDialog.name !== ''){
              this.projectIdSelect = this.projectDialog.id
            }
            params = this.getUpdateParams()



            try{
              await putStartJobWithId(params)
              this.printAlert({type: 'success', text: 'اطلاعات رکورد ثبت شد', timeout: 5000})
              this.project=''
              this.description = '';
              this.projectDialog=''
              this.descriptionDialog=''
              this.issueId=''
              this.time = 0
              this.showTime = '۰۰:۰۰:۰۰'
              this.$emit('updateRow')
              this.$store.state.lastTimeId = -1

              this.dialogsMe = false

            }catch (e) {
              this.printAlert({type: 'error', text: 'اطلاعات رکورد ثبت نشد', timeout: 5000})
              this.dialogsMe = false

            }

           this.updateCurrentTimeLoading=false
          },
            ...mapActions({
                getListProjectReq:'listProjects/fetchListProjects',
                printAlert:'alert/printAlert',


            }),
        },
        watch:{
            dialogsMe(){
                if(this.dialogsMe===false) {
                    this.$emit('parentevent')
                }
            },
            dialogs(){
                if(this.dialogs){
                  this.dialogsMe = true
              }
            },
            startTime(){
                if(this.startTime==="00:00")
                {
                    this.startColor = '#BBBBBB'
                    this.startBackground = '#F3F3F3'
                }
                else {
                    this.startColor  = '#00CE81'
                    this.startBackground = 'white'
                }
            },
            endTime(){
                if(this.endTime==="00:00")
                {
                    this.endColor = '#BBBBBB'
                    this.endBackground = '#F3F3F3'
                }
                else {
                    this.endColor  = '#00CE81'
                    this.endBackground = 'white'
                }
            },

        },
        computed:{
            ...mapGetters({
                originalListProjects:'listProjects/get_listProjects',
                user_profile: 'user/getUserProfile'

            }),
          updateItemOfProject:{
              get(){
                return this.projectDialog.name
              },
            set(e){
              this.originalListProjects.forEach((project)=>{
                if(project.name === e){
                  this.projectDialog = project
                }
              })
            }
          },
        },
        async mounted() {

          if(this.edit.start_time!==undefined) {

               if(this.edit.issue.id !==null) {
                 this.myIssue = this.edit.issue

                 this.issueId= this.edit.issue.id
               }
               // this.projectDialog = this.edit.project.name
               //از props edit برای پر کردن داده های توضیحات
               this.descriptionDialog = this.edit.description === null ? '' : this.edit.description

               //زمان پایان
               this.edit.endEnglishTime = toMinutesTime(this.edit.endEnglishTime)

               this.dateEndDialog = this.edit.endEnglishDate +' ' + this.edit.endEnglishTime
               this.datetimeEnd = this.edit.end_time+' '+this.edit.endDate
               //زمان شروع
               this.edit.startEnglishTime = toMinutesTime(this.edit.startEnglishTime)
               this.dateStartDialog = this.edit.startEnglishDate+' '+this.edit.startEnglishTime
               this.datetimeStart = this.edit.start_time+' '+this.edit.startDate

               //لیست پروژه ها
            this.projectDialog = this.edit.project



             }
            this.checkHasIntegration()
            //max for tarikh
            //برای گرفتن زمان الان و محدودیت در تقویم برای تاریخ هایی که هنوز نرسیده است
            //getNowTimes() یک متد است که برای گرفتن زمان الان استفاده می شود
            this.nowTime = getNowTimeWithHour()

            //گرفتن لیست پروژه های کاربر از سرور برای v-select
            await this.getListProjectReq()
            //چون عناصر originalListProjects یک ارایه ای از object ها هستند
            // بنابراین در هر نوبت نام ان در items قرار گرفته می شود که به کاربر نمایش داده شود
            this.originalListProjects.forEach((project)=>{
                this.items.push(project)
            })


          this.dataComing = true

        }
    }
</script>
<style>
   .describes .v-input__control{
     overflow-y: auto;
     overflow-x:hidden;
     max-height: 125px;
   }
</style>
<style scoped>
 .toolbar{
     color: white !important;
     font-size: 1rem;
     font-family: iranYekan;
 }
 .content-dialog{
     font-family: iranYekan;
     font-size: 0.75rem;
     display: grid;
     grid-row-gap: 10px;
 }

 .grid-help{
   display: grid;
   grid-template-columns: 7fr  auto;

 }
 .grid-help .first-child{
   grid-column: 1;
   display: grid;
   grid-template-columns: auto auto;
   align-items: center;
   justify-content: flex-start;
   margin-left: 7px;
 }
 .grid-help .first-child .titles{
   margin-right: 7px;
   color: #BBBBBB;
 }
 .grid-help .second-child{
   grid-column:  3;
 }

 .time-chip{
     width: 118px;
     height: 35px;
     justify-content: center;
     align-items: center;
     margin-right: 0.9rem;
 }

 .active-date{
     border-radius: 16px;
     border:1px solid #00CE81 !important; ;
     width: 150px;
     padding: 10px;
     height: 35px;
     margin-right: 0.925rem;
     font-size: 0.875rem;
     font-weight: normal;
     font-family: iranYekan;
     color: #5A5A5A !important;
     background-color: white !important;

 }
 .dis-active-date{
     border-radius: 16px;
     border:1px solid #BBBBBB !important;
     width: 150px;
     padding: 10px;
     height: 35px;
     background-color:  rgb(243, 243, 243) !important;
     font-size: 0.75rem;
     font-weight: normal;
     font-family: iranYekan;
 }
 .dis-end-active-date{
   border-radius: 16px;
   border:1px solid #BBBBBB !important;
   width: 150px;
   padding: 10px;
   height: 35px;
   background-color:  rgb(243, 243, 243) !important;
   font-size: 0.75rem;
   font-weight: normal;
   font-family: iranYekan;
 }
 .end-active-date{
   border-radius: 16px;
   border:1px solid #00CE81 !important; ;
   width: 150px;
   padding: 10px;
   height: 35px;
   font-size: 0.875rem;
   font-weight: normal;
   font-family: iranYekan;
   color: #5A5A5A !important;
   background-color: white !important;

 }

 .calendar input::placeholder{
     color: #BBBBBB;
 }
 textarea:focus, input:focus{
     outline: none;
 }

 .active-project{
     border:1px solid #00CE81 ;
     height: 35px;
     width: 150px;
     padding: 0 10px;
     font-size: 0.75rem;
     font-family: iranYekan;
 }
 .dis-active-project{
     border:1px solid #BBBBBB;
     width: 150px;
     padding: 0 10px;
     height: 35px;
     font-size: 0.75rem;
     font-family: iranYekan;
 }
 .describes{
 }
 .active-describe{
     border:1px solid #00CE81 ;
     width: 250px !important;
     /*max-height: 150px;*/
     height: max-content !important;
     padding: 10px;
     background-color: white;
     font-size: 0.875rem;
     font-family: iranYekan;
     color: #5A5A5A;

 }
 .dis-active-describe{
     border:1px solid #BBBBBB;
     width: 250px !important;
     max-height: 150px;
     height: max-content !important;
     padding: 6px;
     font-size: 0.75rem;
     font-family: iranYekan;
     color: #BBBBBB;
 }
 .button{
   align-self: center;
   justify-self: center;
 }
 .active-button{
     border:1px solid #00CE81 ;
     background-color: #00CE81 !important;
     color: white !important;
     font-size: 1rem;
     font-family: iranYekan;
 }
 .dis-active-button{
     border:1px solid #BBBBBB;
     color:  #BBBBBB !important;
     font-size: 1rem;
     font-family: iranYekan;
 }
</style>
